import { clubbiStyled, Spinner } from 'clubbi-ui'

export const StyledContainer = clubbiStyled('div')(({ theme }) => ({
  paddingTop: '30px',
  backgroundColor: '#ffffff',
}))

export const StyledHeader = clubbiStyled('div')(({ theme }) => ({
  marginBottom: '15px',
  textAlign: 'center',
  h2: {
    fontSize: '30px',
    lineHeight: '36px',
    marginBottom: '15px',
    paddingBottom: '10px',
    margin: 0,
    color: theme.palette.brandPurple.main,
    fontWeight: 700,
  },
  p: {
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 500,
    color: theme.palette.brandGrey[100],
  },
}))

export const StyledSubtext = clubbiStyled('p')(({ theme }) => ({
  fontSize: '16px',
  color: '#4A5565',
  textAlign: 'center',
  marginBottom: '10px',
}))

export const StyledFormGroup = clubbiStyled('div')({
  marginBottom: '15px',
})

export const StyledLabel = clubbiStyled('div')(({ theme }) => ({
  fontWeight: '700',
  marginBottom: '4px',
  fontSize: theme.typography.fontSizeXS,
  color: theme.palette.brandGrey[100],
}))

export const StyledOptionalText = clubbiStyled('span')(({ theme }) => ({
  fontSize: theme.typography.fontSize2XS,
  color: theme.palette.brandGrey.main,
  marginLeft: '5px',
}))

export const StyledRequiredAsterisk = clubbiStyled('span')({
  color: 'red',
  marginLeft: '4px',
})

export const StyledInput = clubbiStyled('input')<{ requiredEmpty?: boolean }>(
  ({ theme, requiredEmpty }) => ({
    padding: '10px',
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '4px',
    border: `1px solid ${
      requiredEmpty ? theme.palette.brandAlert.main : theme.palette.brandGrey[60]
    }`,
    fontSize: theme.typography.fontSizeS,
    color: theme.palette.brandGrey[100],
    outline: 'none',
    transition: 'border-color 0.2s',
  })
)

export const StyledSelect = clubbiStyled('select')<{ requiredEmpty?: boolean }>(
  ({ theme, requiredEmpty }) => ({
    padding: '10px',
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '4px',
    border: `1px solid ${
      requiredEmpty ? theme.palette.brandAlert.main : theme.palette.brandGrey[60]
    }`,
    fontSize: theme.typography.fontSizeS,
    color: theme.palette.brandGrey[100],
    outline: 'none',
    transition: 'border-color 0.2s',
    backgroundColor: theme.palette.brandWhite.main,
    appearance: 'none',
  })
)

export const StyledError = clubbiStyled('p')(({ theme }) => ({
  color: theme.palette.brandAlert.main,
  fontSize: theme.typography.fontSize2XS,
  marginTop: '5px',
  margin: 0,
}))

export const StyledSubmitContainer = clubbiStyled('div')({
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'end',
})

export const StyledSaveButton = clubbiStyled('button')<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    padding: '6px 20px',
    backgroundColor: disabled ? theme.palette.brandGrey[30] : theme.palette.brandPurple[60],
    color: theme.palette.brandWhite.main,
    border: 'none',
    borderRadius: '4px',
    fontWeight: '700',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: theme.typography.fontSizeXS,
    transition: 'background-color 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '60px',

    [theme.breakpoints.up('sm')]: {
      marginBottom: '20px',
    },
  })
)

export const StyledSpinner = clubbiStyled(Spinner)(({ theme }) => ({
  width: '18px !important',
  height: '18px !important',
  color: theme.palette.brandWhite.main,
}))
